<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent width="80%">
      <v-card>
        <v-card-title>
          <span class="headline">Alterar Previsão de Quadro Horário</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md2>
                <v-text-field color="primary" label="Nr Registro" disabled :value="linha.numeroRegistro"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md5>
                <v-text-field color="primary" label="Nome" disabled :value="linha.nome"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md5>
                <v-text-field color="primary" label="Função" disabled :value="linha.funcao"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm6 md1>
                <v-text-field type="number" min="0" v-model.number="linha.qhDom" label="Dom"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field type="number" min="0" v-model.number="linha.qhSeg" label="Seg"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field type="number" min="0" v-model.number="linha.qhTer" label="Ter"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field type="number" min="0" v-model.number="linha.qhQua" label="Qua"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field type="number" min="0" v-model.number="linha.qhQui" label="Qui"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field type="number" min="0" v-model.number="linha.qhSex" label="Sex"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md1>
                <v-text-field type="number" min="0" v-model.number="linha.qhSab" label="Sab"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="close">Cancelar</v-btn>
          <v-btn color="primary" type="submit" @click.native="confirmar" dark>Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import qhPrevisaoService from "@/service/qh/QhPrevisaoService";
import QhPrevisaoLinha from "@/model/qh/QhPrevisaoLinha";
import EventBus from "@/utils/EventBus";
export default {
  name: "ModalEdicaoQhPrevisao",
  data() {
    return {
      dialog: false,
      linha: new QhPrevisaoLinha()
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    EventBus.$on("editaQhPrevisao", async idPrevisao => {
      const linha = await qhPrevisaoService.buscarPorId(idPrevisao);
      if (linha) {
        this.linha = linha;
        this.dialog = true;
      }
    });
  },
  methods: {
    confirmar() {
      qhPrevisaoService
        .alterar({
          id: this.linha.id,
          qhDom: this.linha.qhDom,
          qhSeg: this.linha.qhSeg,
          qhTer: this.linha.qhTer,
          qhQua: this.linha.qhQua,
          qhQui: this.linha.qhQui,
          qhSex: this.linha.qhSex,
          qhSab: this.linha.qhSab
        })
        .then(retorno => {
          if (retorno) {
            this.$emit("qhPrevisaoCadastrada", true);
            this.close();
          }
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.linha = new QhPrevisaoLinha();
      }, 300);
    }
  }
};
</script>
